(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kit-builder-end"]) return;
  try {
    
  $('body').on('click', '#kit-builder--final-boxes .step-one--single', function(e){
    e.preventDefault();
    box_replace($(this))
  });
  
  $('.addon-variant-list--single .addon-variant-list--single-variant-image').on('click',function(){
    var $single_el = $(this).closest('.addon-variant-list--single'),
        $addon_input = $single_el.find('input'),
        name = $addon_input.attr('name'),
        var_id = $(this).data('variant_id'),
        var_title = $(this).data('variant_name'),
        var_image = $(this).data('variant_image'),
        var_price = $(this).data('variant_price');
    $single_el.find('.addon-variant-list--single-variant-image').removeClass('active');
    $(this).addClass('active');
    $single_el.find('.addon-variant-list--single-image').css('background-image','url('+ var_image +')');
    $single_el.find('.addon-variant-list--single-text em').text(var_title);
    $single_el.find('.addon-variant-list--single-text span').text(Shopify.formatMoney(var_price).replace('.00',''));
    $addon_input.val(var_id).data('type', $(this).data('product_title') +' - '+ var_title).data('variant_image', var_image).data('variant_price',var_price);
    console.log('')
    $('.kit--collections-checkout--items_addons .checkout-item.'+ name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')).remove();
    var el_data = $addon_input.data(),
        data_array = [];
    data_array.push({'name': 'id','value': $addon_input.val()});
    $.each(el_data,function(i,v){
      var data_object = {};
      data_object['name'] = i;
      data_object['value'] = v;
      data_array.push(data_object);
    });
    buildKitItem(data_array,name,'.kit--collections-checkout--items_addons',true);
  });
  
  $('.addon-variant-list--single input').on('change',function(){
    var select_text = $(this).val() != '' ? $(this).next('label').clone().children().remove().end().text() : 'None Selected',
        name = $(this).attr('name');
    $(this).closest('li').find('.link-title span').text(select_text);
    $('.kit--collections-checkout--items_addons .checkout-item.'+ name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')).remove();
    if($(this).val() != ''){
      var el_data = $(this).data(),
          data_array = [];
      data_array.push({'name': 'id','value': $(this).val()});
      $.each(el_data,function(i,v){
        var data_object = {};
        data_object['name'] = i;
        data_object['value'] = v;
        data_array.push(data_object);
      });
      buildKitItem(data_array,name,'.kit--collections-checkout--items_addons',true);
    }
  });

  $(document).ready(function(){
    $('.addon-variant-list--single').each(function(){
      var $curr_input = $(this).find('input:checked');
      if($curr_input.length > 0 && $curr_input.val() !== '') {
        var name = $curr_input.attr('name'),
            el_data = $curr_input.data(),
            data_array = [];
        data_array.push({'name': 'id','value': $curr_input.val()});
        $.each(el_data,function(i,v){
          var data_object = {};
          data_object['name'] = i;
          data_object['value'] = v;
          data_array.push(data_object);
        });
        buildKitItem(data_array,name,'.kit--collections-checkout--items_addons',true);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kit-builder-header"]) return;
  try {
    
  $('body').on('click', '[data-clickable="true"]', function(){
    var step_need = $(this).data('step'),
        prev_step = step_need*1 - 1;
    updateStep(prev_step,step_need);
  });

  $('body').on('change', '.kit-filter--single', function(){
    update_filters();
  });
  
  $('#return-to-prev').on('click',function(){
    var curr_step = $('.kitbuilder-step .active').data('step');
    updateStep(curr_step,1);
  });
  
  $(document).ready(function(){
    $('#kit-header--filters').contents().appendTo('#kit-collections-main--step2_filters');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kit-builder-main"]) return;
  try {
    
  $(document).ready(function(){
    
    $('.kit-collections-main--step2').on('keyup', '.on-page-search', function () {
      var v = $(this).val();
      $('.results').removeClass('results');
      $(this).closest('.kit-collections--wrapper').find('.kit-builder-single').each(function () {
        if (v != ''){
          $(this).closest('.row--collect').addClass('search_performed');
          if($(this).find('.kit-builder-single--name').text().search(new RegExp(v,'gi')) != -1) {
            $(this).addClass('results');
          }
        } else {
          $(this).closest('.row--collect').removeClass('search_performed');
        }
      });
    });
    
    var box = getUrlParameter('b'),
        collects = getUrlParameter('c'),
        name = getUrlParameter('n'),
        prods = getUrlParameter('p'),
        min_param = getUrlParameter('min'),
        prod_handle = getUrlParameter('base');
    if (typeof collects  !== 'undefined') {
      var collects_array = collects.split(','),
          count = collects_array.length,
          buildable = false;
      $('.kit-name').val(name.replace(/\+/g, ' '));
      $('.kit--collections-picked-title').text(name.replace(/\+/g, ' '));
      $('.kits-complete').addClass('step1-skip');
      updateStep(1,2);
      $('.kit--collections,.kit--header-adjustments').addClass('prod_pick');
      
      $('.kit-builder--step1,.kit--header,.kit--header-adjustments,.btn--add-more,.kit-collections-main--step1').hide();
      $('.kit-collections-main--step2,.kit--collections-checkout,.kit-builder--step2').show();
      
      $('.kit--collections-picked h4').text(name.replace(/\+/g, ' '));
      
      if(typeof prods  !== 'undefined') {
        var prods_array = prods.split(',');
        shared_kititem(prods_array);
      }
      
      if(typeof min_param !== 'undefined') {
        min_qty = min_param;
      }
      $('#Quantity').attr('min',min_qty).val(min_qty).trigger('change');
      $('.qty_min').find('span').text(min_qty);

      if(typeof prod_handle !== 'undefined') {
        $.getJSON('/products/'+ prod_handle +'.js', function(product) {
          var featured_image = product.featured_image,
              featured_image_extension = featured_image.lastIndexOf('.'),
              image_resized = featured_image.substr(0, featured_image_extension) + '_800x' + featured_image.substr(featured_image_extension);
          $('.kit--collections-image').attr('src',image_resized).addClass('prebuilt_image');
          $('.kit--collections-checkout-single.prebuilt_show > div').html(product.description);
        }).fail(function(jqXHR, textStatus, errorThrown) {
          console.log('failed');
        }); 
      }
      
      if(typeof box !== 'undefined') {
        $('.step-one--single[data-id="'+ box +'"').trigger('click');
        var el_data = $('.step-one--single.active').data(),
            data_array = [];
        $.each(el_data,function(i,v){
          var data_object = {};
          data_object['name'] = i;
          data_object['value'] = v;
          data_array.push(data_object);
        });
        buildKitItem(data_array,'box','.kit--collections-checkout--items_box',false);
      }
      
      shared_build(collects_array);
    }
  });
                          
  $('.btn--add-more').on('click',function(){
    $('.kit--collections,.kit--header-adjustments').removeClass('prod_pick');
    $('.kit-collections-main--step1,.kit--collections-continue .btn--continue').show();
    $('.kit-collections-main--step2').hide();
    $('.kit--collections-checkout').removeClass('collections_picked');
    terminate = true;
  });
  
  $('.kit-collections-main--step2').on('click','.kit-builder-single--featured,.kit-builder-single--name',function(e){
    e.preventDefault();
    single_product_build($(this).data('handle'),null,$(this).closest('.row').attr('data-collect'),$(this).closest('.kit-builder-single').attr('data-min'));
  });
  
  $('.kit-collections-main--step2').on('click','.kit-builder-single--variant-image',function(){
    $(this).closest('.kit-builder-single--container').find('.active').removeClass('active');
    $(this).addClass('active');
    var $prod_image = $(this).closest('.kit-builder-single--container').find('.kit-builder-single--featured'),
        image = $(this).data('image');
    $prod_image.fadeOut(350, function() {
      $(this).css('background-image', 'url('+ image +')');
      $(this).fadeIn(350);
    });
  });
  
  $('.kit-collections-main--step2').on('click','.expander',function(){
    $(this).closest('.row').css('height', '100%');
    var h = $(this).closest('.row').height();
    $(this).closest('.row').css('height', $(this).closest('.row').find('.kit-builder-single').first().outerHeight()*2 + 60);
    $(this).closest('.row').animate({height: h}, 350, function() {
      $(this).closest('.row').removeClass('collapsed row--collect-building').css('height','auto');
    });
  });
  
  $('.kit-collections-main--step2').on('click','.link-title',function(e){
    if($(e.target).is('input')) return;
    var $this = $(this),
        $next = $this.next();

    $next.slideToggle();
    $this.toggleClass('closed');
  });
  
  $('body').on('click','#kit-builder--final-boxes .link-title',function(){
    var $this = $(this),
        $next = $this.next();

    $next.slideToggle();
    $this.toggleClass('closed');
  });
  
  $('#purchase-form').on('click','.product-single__thumbnail',function(e){
    e.preventDefault();
    updateFeatured($(this));
  });
  
  $('#purchase-form').on('change','.swatch :radio',function() {
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();
    $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
    var getCurrentOptions = $.map($('#purchase-form .single-option-selector'), function(element) {
          var $element = $(element),
              currentOption = {};
          currentOption[$element.data('index')] = $element.val();
          return currentOption;
        }),
        variants = JSON.parse($('#purchase-form #VariantJson').html()),
        found = variants.filter(function(item) {
          var isValid = true;
          getCurrentOptions.forEach((element, index) => {
            for (var key in element) {
              if (item[key] === undefined || item[key] != element[key]) {
                isValid = false;
              }
            }
          });
          if (isValid) {
            return true;
          } else {
            return false;
          }
        }),
        slider_image_no = $('#purchase-form .product-form__variants option[value="'+ found[0].id +'"]').data('image-connect'),
        $slider_image = $('#purchase-form .product-single__thumbnail[data-imageid="'+ slider_image_no +'"]'),
        slide_index = $slider_image.parent('li:not(.slick-cloned)').data('slick-index'),
        decoration_price = $('#purchase-form input[name="decoration"]:checked').length ? $('#purchase-form input[name="decoration"]:checked').data('price') : 0,
        add_to_kit_text = product_add_to_kit;
    if($('#purchase-form .product-form__cart-submit:visible').hasClass('product-form__cart-update')) {
      add_to_kit_text = 'Update Item';
    }
    found[0].available ? $('#purchase-form .product-form__cart-submit').attr('disabled',false).text(add_to_kit_text) : $('#purchase-form .product-form__cart-submit').attr('disabled',true).text(product_sold_out);
    
    $('#purchase-form .single-product-price').text(Shopify.formatMoney(found[0].price + decoration_price).replace('.00',''));
    $('#purchase-form').find('#Price').val(found[0].price + decoration_price);
    $('#purchase-form .product-form__variants').val(found[0].id);
    if ($slider_image.length && $('#purchase-form .product-featured-img').attr('src') != $slider_image.attr('href')) {
      $('#purchase-form .product-single__thumbnails').slick('slickGoTo', slide_index);
      updateFeatured($slider_image);
      $('#purchase-form #Image').val($slider_image.attr('href'));
    }
  });
  
  $('#purchase-form').on('change','input[name="decoration"]',function(){
    var decoration_price = $(this).data('price'),
        base_price = $('#purchase-form').find('#Price').data('base'),
        price = base_price + decoration_price;
    $('#purchase-form').find('.single-product-price').text(Shopify.formatMoney(price).replace('.00',''));
    $('#purchase-form').find('#Price').val(price);
  });
  
  $('#purchase-form').on('submit','form',function(e) {
    e.preventDefault();
    $('input[value=""]', this).remove();
    var added_data = JSON.parse(JSON.stringify($(this).serializeArray())),
        updated = $('#purchase-form').hasClass('updating') ? true : null,
      	collection = $('#purchase-form').attr('data-collection'),
        min = $('#purchase-form').attr('data-min_qty');
    console.log('added_data',added_data)
    buildKitItem(added_data,null,null,true,updated,collection,min);
  });
    
  $('.kits-complete').on('click','.btn--kit-remove',function(e){
    e.preventDefault();
    $(this).closest('.checkout-item').fadeOut(350, function() {
      var data_handle = $(this).find('.checkout-item-text--title').data('id');
      $(this).remove();
      updateKitPrice();
    });
  });

  $('.kits-complete').on('click','.btn--kit-view',function(e){
    e.preventDefault();
    var $checkout_item = $(this).closest('.checkout-item');
    if($checkout_item.hasClass('box')) {
      updateStep(2,1);
    } else {
      var prod_handle = $checkout_item.find('.checkout-item-text--title').data('id');
      $(this).closest('li').addClass('updating');
      single_product_build(prod_handle,'updating');
    }
  });
  
  $('.kits-complete').on('keypress','#Quantity',function(e) {
    if(e.which == 13) {
      $('#Quantity').val($(this).val()).trigger('change').trigger('blur');
      return false;
    }
  });
    
  $('.kits-complete').on('change','#Quantity',function(){
    var this_min = $(this).attr('min')*1,
        this_val = $(this).val()*1;
    min_qty = this_val;
    if (typeof $(this).attr('min') !== typeof undefined && $(this).attr('min') !== false && this_val < this_min) {
      $(this).val($(this).attr('min'));
    }
    if($('#min-qty').val()*1 != this_val) {
      $('#min-qty').val(this_val).trigger('change');
    }
    updateProdVisibility($(this).val());
    updateKitPrice();
    updateStepContinue(this_val);
    $('.kit-collections-main .row').each(function(){
      prods_moreAvailable($(this).data('collect'));
    });
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kit-builder-start"]) return;
  try {
    
  $('.kits-complete').on('change','#min-qty',function(e) {
    var this_min = $('#Quantity').attr('min')*1,
        this_val = $(this).val()*1;
    if (typeof $(this).attr('min') !== typeof undefined && $(this).attr('min') !== false && this_val < this_min) {
      $(this).val($(this).attr('min'));
    } else {
      $('#Quantity').val(this_val).trigger('change').trigger('blur');
      return false;
    }
  });

  $('.kit-builder--step1').on('click','.kit_type_toggle',function(){
    $(this).toggleClass('expanded').next('div').toggleClass('expanded');
  });
      
  $('.kit-builder--step1').on('click','.step-one--single',function(e){
    e.preventDefault();
    console.log('step one hit');
    box_replace($(this));
  });
    
  $('.btn--continue').on('click',function(){
    var curr_step = $(this).data('currentstep'),
        next_step = $(this).data('continuestep');
    updateStep(curr_step,next_step);
  });
  
  $('.collection-grid-item__link').on('click',function(){
    update_wanted_collections($(this));
  });
    
  $('#step-one--continue').on('click',function(){
    $('.kit--collections-checkout--items_box .checkout-item.box').remove();
    var el_data = $('.step-one--single.active').data(),
        data_array = [];
    $.each(el_data,function(i,v){
      var data_object = {};
      data_object['name'] = i;
      data_object['value'] = v;
      data_array.push(data_object);
    });
    buildKitItem(data_array,'box','.kit--collections-checkout--items_box',false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
    }
  }

  document.querySelectorAll('.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-conservation"]) return;
  try {
    
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
    }
  }

  document.querySelectorAll('.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    


  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductDetails extends HTMLElement {
    constructor() {
      super();
    }
  }

  customElements.define('product-details', ProductDetails);

  class ProductFeatures extends HTMLElement {
    constructor() {
      super();
    }
  }

  customElements.define('product-features', ProductFeatures);

  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
    }
  }

  document.querySelectorAll('.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  const compatible_modal = document.getElementById('compatible-products');
  if(compatible_modal) {
    const compatible_btn = document.getElementsByClassName('compatible-products--btn')[0];
    const compatible_close = compatible_modal.getElementsByClassName('close')[0];
    compatible_btn.onclick = function() {
      compatible_modal.style.display = 'block';
      document.body.classList.add('no-scroll');
    }
    compatible_close.onclick = function() {
      compatible_modal.style.display = 'none';
      document.body.classList.remove('no-scroll');
    }
    window.onclick = function(event) {
      if (event.target == compatible_modal) {
        document.body.classList.remove('no-scroll');
        compatible_modal.style.display = 'none';
      }
    }
  }



    if(document.querySelectorAll('.product__media-list > li.product__media-item--variant_current').length == 1){
    document.querySelectorAll('.product__media-item--variant_current').forEach(element => element.classList.add('soloimg'))
    } 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parent-collection-product-grid"]) return;
  try {
    
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
    }
  }

  document.querySelectorAll('.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              const grid_items = this.querySelectorAll('.card-link');
              click_alter(grid_items);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
